import styled from 'styled-components';

export default styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  transition: transform 0.16s linear, opacity 0.08s linear;
  color: ${(props) => props.theme.primaryColor};
`;
